import { type IUserServiceProvider, type UserType, type UserWithGoalsAndKpisType } from '#domain/user';
import ApiClient from '#infra/config/api.client';

type DateInputType = string | number | Date;

export class UserServiceProvider implements IUserServiceProvider {
  async getMe(): Promise<UserType> {
    const response = await ApiClient.get(`/verify-token`);
    return {
      email: response.data.email,
      fullName: response.data.name
    };
  }
  async getUserWithGoalsAndKpis(): Promise<UserWithGoalsAndKpisType> {
    const response = await ApiClient.get(`/users`);
    const userResponse = response.data;
    const { emailAddress, ...rest } = userResponse;

    const adaptedUser = {
      ...rest,
      email: userResponse.emailAddress,
      barcodes: userResponse.barcodes?.map(
        (barcode: {
          code: string;
          codeWithLabel: string;
          formats: Array<{
            launchDate: DateInputType;
            scopeStartDate: DateInputType;
          }>;
        }) => ({
          ...barcode,
          formats: barcode.formats?.map((format: { launchDate: DateInputType; scopeStartDate: DateInputType }) => ({
            ...format,
            launchDate: new Date(format.launchDate),
            scopeStartDate: new Date(format.scopeStartDate)
          }))
        })
      )
    };
    return adaptedUser;
  }
}
